/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class GmaoPreventivePlanningWeek {

    /**
     * Check if the preventive sheet is edited
     *
     * @param creation date string
     * @param update date string
     * @return {boolean}
     */
    isEdited(creation, update) {
        let creationDate = new Date(creation);
        let updateDate = new Date(update);
        updateDate.setHours(updateDate.getHours() -1);
        return updateDate > creationDate;
    }
}

export const gmaoPreventivePlanningWeekComponent = {
    template: require('./gmao-preventive-planning-week.html'),
    controller: GmaoPreventivePlanningWeek,
    bindings: {
        week: '<',
        preventiveSheets: '<'
    }
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/prevention/component/GmaoPreventivePlanningWeek.js